<template>
  <v-dialog
    v-model="showLocal"
    max-width="500"
    persistent
  >
    <v-card>
      <v-card-title class="error white--text">
        <v-icon
          color="white"
          class="mr-2"
        >
          mdi-alert-circle
        </v-icon>
        eLearning Request Failed
        <v-spacer />
        <v-btn
          icon
          color="white"
          @click="close"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-6 pb-4">
        <div class="text-h6 mb-2">
          {{ errorTitle }}
        </div>
        <div class="text-body-1">
          {{ errorMessage }}
        </div>
      </v-card-text>

      <v-card-actions class="justify-center pb-4">
        <v-btn
          color="primary"
          min-width="120"
          rounded
          @click="close"
        >
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import dialog from '@/mixins/dialog';

export default {
  name: 'GHLErrorDialog',

  mixins: [dialog],

  props: {
    errorTitle: {
      type: String,
      default: 'Request Failed',
    },
    errorMessage: {
      type: String,
      default: 'An error occurred while processing your eLearning request. Please try again later.',
    },
  },

  methods: {
    close() {
      this.showLocal = false;
      this.$emit('close');
    },
  },
};
</script>
